import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./index.css";
import { BRAND_NAME } from "../branding";

const LoginLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <div className="login-layout">
      <main
        className={`login__mainContainer${
          isHomePage ? " login__mainContainer-home" : ""
        }`}
      >
        {children}
      </main>
      <footer className="login__footer">
        <div className="public-footer-inner">
          <p>&copy; 2026 {BRAND_NAME}. All Rights Reserved.</p>
          <nav aria-label="Legal links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/support">Support</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default LoginLayout;
